import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Rutas relativas para la carpeta src/pages/
import logoIso from '../assets/images/iso9001.jpg';
import politicaES from '../assets/images/politica_es.jpg';
import politicaEN from '../assets/images/politica_eng.jpg'; // Importamos el PDF en inglés
import certificadoEN from '../assets/images/SGS_ISO 9001_2015_ES2600000710_EN-1.jpg';
import certificadoES from '../assets/images/SGS_ISO 9001_2015_ES2600000710_ES-1.jpg';

const QualityPolicyPage = () => {
  const { i18n } = useTranslation();
  const [modalAbierto, setModalAbierto] = useState(false);
  const [documentoModal, setDocumentoModal] = useState('');

  // Detectamos en tiempo real si el idioma de i18next es inglés
  const idiomaActivo = i18n.language || 'es';
  const esIngles = idiomaActivo.toLowerCase().includes('en');

  // Diccionario interno bilingüe limpio
  const textos = {
    es: {
      titulo: "Calidad y Certificaciones",
      subtitulo: "Compromiso con la Excelencia Industrial",
      intro: "En Voltaris Industry & Renewables, S.L. consideramos la Gestión de la Calidad como el pilar fundamental para planificar y desarrollar todas nuestras actividades, garantizando la plena satisfacción de nuestros clientes y el cumplimiento normativo riguroso.",
      alcanceTitulo: "Alcance del Sistema de Gestión:",
      alcance1: "Crimpado y ensamblado de cables eléctricos.",
      alcance2: "Montaje y ensamblaje de cables y componentes eléctricos en envolventes metálicas hasta formar equipos completos.",
      btnPolitica: "Ver Política de Calidad",
      btnCertificado: "Ver Certificado ISO 9001",
      cerrar: "Cerrar Vista"
    },
    en: {
      titulo: "Quality & Certifications",
      subtitulo: "Commitment to Industrial Excellence",
      intro: "At Voltaris Industry & Renewables, S.L., we consider Quality Management as the essential cornerstone to plan and develop all our operations, ensuring full client satisfaction and strict compliance with international standards.",
      alcanceTitulo: "Management System Scope:",
      alcance1: "Crimping and assembly of electrical cables.",
      alcance2: "Assembly and mounting of cables and electrical components in metal enclosures to form complete equipment.",
      btnPolitica: "View Quality Policy",
      btnCertificado: "View ISO 9001 Certificate",
      cerrar: "Close View"
    }
  };

  const t = esIngles ? textos.en : textos.es;

  const abrirVisor = (tipo) => {
    if (tipo === 'politica') {
      // Si está en inglés carga el PDF, si no, la imagen en español
      setDocumentoModal(esIngles ? politicaEN : politicaES);
    } else {
      // Inyecta el certificado correspondiente según el idioma activo
      setDocumentoModal(esIngles ? certificadoEN : certificadoES);
    }
    setModalAbierto(true);
  };

  return (
    <div className="pt-32 mt-4 min-h-screen bg-white">
      <div className="max-w-6xl mx-auto px-4 py-8 font-sans">
        
        {/* Encabezado Principal */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-3">{t.titulo}</h2>
          <p className="text-lg md:text-xl font-semibold text-primary tracking-wide">{t.subtitulo}</p>
          <p className="text-base leading-relaxed text-gray-600 max-w-3xl mx-auto mt-6">
            {t.intro}
          </p>
        </div>

        <hr className="border-gray-200 my-10" />

        {/* Bloque Central: Sello Oficial + Alcance */}
        <div className="flex flex-col md:flex-row gap-10 items-center justify-center mb-12">
          <div className="w-full md:w-1/3 flex justify-center">
            <img 
              src={logoIso} 
              alt="SGS ISO 9001 ENAC Certification" 
              className="w-56 h-auto object-contain" 
            />
          </div>

          <div className="w-full md:w-2/3 bg-gray-50 p-8 rounded-lg border-l-4 border-primary shadow-sm">
            <h3 className="text-lg font-bold text-secondary mb-4">{t.alcanceTitulo}</h3>
            <ul className="list-disc list-inside space-y-3 text-gray-700 leading-relaxed">
              <li>{t.alcance1}</li>
              <li>{t.alcance2}</li>
            </ul>
          </div>
        </div>

        {/* Botones de Acción */}
        <div className="flex flex-wrap gap-4 justify-center items-center">
          <button 
            onClick={() => abrirVisor('politica')} 
            className="px-6 py-3 bg-secondary hover:bg-secondary/90 text-white font-semibold rounded shadow transition-all duration-200 flex items-center gap-2"
          >
            📄 {t.btnPolitica}
          </button>
          
          <button 
            onClick={() => abrirVisor('certificado')} 
            className="px-6 py-3 bg-primary hover:bg-primary/90 text-white font-semibold rounded shadow transition-all duration-200 flex items-center gap-2"
          >
            🏅 {t.btnCertificado}
          </button>
        </div>

        {/* VISOR MODAL EN PANTALLA COMPLETA */}
        {modalAbierto && (
          <div className="fixed inset-0 bg-black/85 z-[99999] flex flex-col justify-center items-center p-4">
            <button 
              onClick={() => setModalAbierto(false)} 
              className="absolute top-6 right-6 px-4 py-2 bg-primary hover:bg-primary/90 text-white font-bold rounded shadow transition-colors z-[100000]"
            >
              {t.cerrar} ✕
            </button>
            
            <div className="max-w-full max-h-[85vh] overflow-y-auto bg-white p-2 rounded shadow-xl">
              {/* Si el archivo seleccionado termina en .pdf usamos un iframe, si no, una img normal */}
              {documentoModal.endsWith('.pdf') ? (
                <iframe 
                  src={documentoModal} 
                  title="Quality Policy PDF"
                  className="w-[80vw] h-[80vh] max-w-3xl block"
                />
              ) : (
                <img 
                  src={documentoModal} 
                  alt="Documento de Calidad" 
                  className="w-full h-auto max-w-2xl block" 
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QualityPolicyPage;